export default __webpack_public_path__ + "static/media/instituteManagementIcon.49575744.svg";